import {Component, EventEmitter, Inject, OnInit, Output, ViewChild} from '@angular/core';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from '@angular/material/bottom-sheet';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {AcceptTermsMobileComponent} from '../accept-terms-mobile/accept-terms-mobile.component';
import {URLS} from '../../../environments/environment';
import {ShareService} from 'ngx-sharebuttons';
import {saveAs} from 'file-saver';
import {OrdersService} from '../../dashboard/orders/orders.service';
import {ShareOrderComponent} from '../../ff-shared/share-order/share-order.component';
import {TranslateService} from '@ngx-translate/core';
@Component({
  selector: 'app-calculation-mobile',
  templateUrl: './calculation-mobile.component.html',
  styleUrls: ['./calculation-mobile.component.scss']
})
export class CalculationMobileComponent implements OnInit {
  URLS: any = URLS;
  shareUrl = URLS.API;

  @Output() orderSaved = new EventEmitter<boolean>();
  @ViewChild(ShareOrderComponent) shareOrderComponent: ShareOrderComponent;
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private dialog: MatDialog,
    private ordersService: OrdersService,
    private share: ShareService,
    private translateService: TranslateService,
    private bottomSheetRef: MatBottomSheetRef<CalculationMobileComponent>) {
  }

  public methodLabelDisplay(method: any): string {
    if (!method) { return ''; }
    return this.translateService.currentLang === 'en'
      ? `${(method.methodName || '').toUpperCase()} Import`
      : (method.methodLabel || '');
  }

  ngOnInit(): void {
    this.share.addButton('pfdDownload', {
      type: 'pdfButton',
      text: 'pdf',
      icon: ['fas', 'fas fa-file-pdf'],
    });
  }

  close() {
    this.bottomSheetRef.dismiss({pdf: false});
  }

  saveOrder(platform: string): void {
    this.ordersService.createNewOrder(this.data.Order).subscribe({
      next: (res: any) => {
        if (this.shareOrderComponent) {
          this.shareOrderComponent.order = res.data;
          this.data = { ...this.data, Order: res.data };
          debugger;
          this.shareOrderComponent.onOrderSaved(true, platform);
        }
      },
      error: (err) => {
        if (this.shareOrderComponent) {
          this.shareOrderComponent.onOrderSaved(false, platform);
        }
      }
    });
  }

  SHARE(platform: string) {
    switch (platform) {
      case 'print':
        window.open(this.shareUrl + 'pdf/' + this.data.Order?.slug.slug + '?print=true');
        break;
      case 'whatsapp':
        window.open(`https://wa.me?text=${encodeURIComponent(`מצורף תחשיב משוער ליבוא (${this.data.Order?.title || 'הזמנה מספר ' + this.data.Order.id})`)} \n` + this.shareUrl + 'pdf/' + this.data.Order?.slug.slug);
        break;
      case 'savePdf':
        this.ordersService.exportOrderToPdf(this.data.Order).subscribe(res => {
          let blob = new Blob([res], {type: 'application/pdf'});
          saveAs(blob, `order-${this.data.Order?.id}.pdf`);
        });
        break;
      case 'email':
        window.open(`mailto:?subject=מצורף תחשיב משוער ליבוא (${this.data.Order?.title || 'הזמנה מספר ' + this.data.Order?.id})&body=${encodeURI(this.shareUrl + 'pdf/' + this.data.Order?.slug.slug)}`);
        break;
    }
  }

  exportToPDF() {
    if (!this.data.Order) {
      const dialog = this.dialog.open(AcceptTermsMobileComponent, {
        width: '100%'
      });
      dialog.afterClosed().subscribe(result => {
        if (!result) {
          return;
        }
        if (result.approve) {
          this.data.order.terms = true;
          this.data.order.importer.imImporter = true;
          this.bottomSheetRef.dismiss({pdf: true});
        }
      });
    } else {
      this.bottomSheetRef.dismiss({pdf: true});
    }
  }

  getMailUrl() {
    return `${URLS.API}pdf/${this.data.Order.slug.slug}`;
  }
}
